<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            خدمات الوقاية من العدوى ومكافحتها (IPC)
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            مستوى تطبيق معايير IPC في المرافق الصحية
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-services')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card success">
          <div class="kpi-value">2/9</div>
          <div class="kpi-label">مرافق بمستوى IPC جيد</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">5/9</div>
          <div class="kpi-label">مستوى متوسط</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">2/9</div>
          <div class="kpi-label">مستوى ضعيف</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">44%</div>
          <div class="kpi-label">متوسط الامتثال لمعايير WHO</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">تقييم تطبيق معايير IPC</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>بروتوكول IPC مكتوب؟</th>
            <th>التخلص من النفايات الطبية</th>
            <th>غسيل الأيدي</th>
            <th>معدات الحماية الشخصية (PPE)</th>
            <th>عزل المرضى</th>
            <th>درجة IPC/100</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>
              <v-chip
                :color="chipColor(item.protocol)"
                size="small"
                variant="flat"
                >{{ item.protocol }}</v-chip
              >
            </td>
            <td>{{ item.waste }}</td>
            <td>
              <v-chip
                :color="chipColor(item.handWash)"
                size="small"
                variant="flat"
                >{{ item.handWash }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.ppe)"
                size="small"
                variant="flat"
                >{{ item.ppe }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.isolation)"
                size="small"
                variant="flat"
                >{{ item.isolation }}</v-chip
              >
            </td>
            <td class="font-weight-bold">{{ item.score }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    protocol: "جزئي",
    waste: "حرق محكوم",
    handWash: "جزئي",
    ppe: "جزئي",
    isolation: "لا يوجد",
    score: 45,
  },
  {
    name: "مستشفى الأمراض النفسية",
    protocol: "لا يوجد",
    waste: "حرق مفتوح",
    handWash: "لا يوجد",
    ppe: "لا يوجد",
    isolation: "لا يوجد",
    score: 22,
  },
  {
    name: "مجمع الشيخ عثمان",
    protocol: "جزئي",
    waste: "حرق محكوم",
    handWash: "جزئي",
    ppe: "جزئي",
    isolation: "لا يوجد",
    score: 48,
  },
  {
    name: "مركز كود العثماني",
    protocol: "كامل",
    waste: "حرق محكوم",
    handWash: "كامل",
    ppe: "كامل",
    isolation: "جزئي",
    score: 70,
  },
  {
    name: "مركز الممدارة",
    protocol: "كامل",
    waste: "حرق محكوم",
    handWash: "كامل",
    ppe: "كامل",
    isolation: "جزئي",
    score: 75,
  },
  {
    name: "مركز المحاريق",
    protocol: "لا يوجد",
    waste: "حرق مفتوح",
    handWash: "جزئي",
    ppe: "لا يوجد",
    isolation: "لا يوجد",
    score: 35,
  },
  {
    name: "مركز عبد القوي",
    protocol: "كامل",
    waste: "حرق محكوم",
    handWash: "كامل",
    ppe: "كامل",
    isolation: "جزئي",
    score: 72,
  },
  {
    name: "مركز ماري ستبوس",
    protocol: "لا يوجد",
    waste: "لا يوجد",
    handWash: "لا يوجد",
    ppe: "لا يوجد",
    isolation: "لا يوجد",
    score: 10,
  },
  {
    name: "جمعية حقوق الطفل",
    protocol: "جزئي",
    waste: "حرق محكوم",
    handWash: "كامل",
    ppe: "جزئي",
    isolation: "لا يوجد",
    score: 60,
  },
];

const chipColor = (value) => {
  if (value === "كامل") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.success {
  background: #e8f5ee;
  color: #1a7a4a;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
